import React from 'react';

import {
  Route      ,
  Routes     ,
  Navigate   ,
  useNavigate,
} from 'react-router-dom';

import { SubTabs                                            } from '../../components'            ;
import { ITopMenuItem                                       } from '../../types/common.interface';
import { LOCATION_SUB_TABS_ADMIN, LOCATION_SUB_TABS_COMPANY } from '../../values/subTabs'        ;

import NotFound from '../NotFound';
import Screens  from './Screens';
import Cookies  from 'js-cookie';
import values   from '../../values';
import utils    from '../../utils';

const LocationScreens: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const navigate = useNavigate();
  const currentMenu = window.location.pathname.split("/")[4];
  const userType = utils.stringHexConversion.reverse(Cookies.get(values.constants.USER.TYPE));
  const [selectedTab, setSelectedTab] = React.useState<ITopMenuItem>(
    userType === 'ADMIN' ?
      LOCATION_SUB_TABS_ADMIN  .find((item) => item.pathname === currentMenu) as ITopMenuItem :
      LOCATION_SUB_TABS_COMPANY.find((item) => item.pathname === currentMenu) as ITopMenuItem
  );

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onTabClick(tab: any) {
    navigate(tab.pathname);
    setSelectedTab(tab);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------ Start UseEffect functions --------------------------------------------

  React.useEffect(() => {
    setSelectedTab(
      userType === 'ADMIN' ?
        LOCATION_SUB_TABS_ADMIN  .find((item) => item.pathname === currentMenu) as ITopMenuItem :
        LOCATION_SUB_TABS_COMPANY.find((item) => item.pathname === currentMenu) as ITopMenuItem
    );
  }, [currentMenu]);

  // ! ------------------------------------------- End UseEffect functions ---------------------------------------------
  // ! =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id='setting-screen'>
      <SubTabs
        tabs={userType === 'ADMIN' ? LOCATION_SUB_TABS_ADMIN : LOCATION_SUB_TABS_COMPANY}
        onClick={onTabClick} selected={selectedTab}
      />
      <Routes>
        { userType === 'ADMIN' ? (
          <>
            <Route path='/' element={<Navigate to={'province'} />} />

            <Route path='/city'         element={<Screens.Admin.CityContainer         />} />
            <Route path='/area'         element={<Screens.Admin.AreaContainer         />} />
            <Route path='/province'     element={<Screens.Admin.ProvinceContainer     />} />
            <Route path='/neighborhood' element={<Screens.Admin.NeighborhoodContainer />} />
          </>
        ):(
          <>
            <Route path='/' element={<Navigate to={'area'} />} />

            <Route path='/area'         element={<Screens.Company.AreaContainer         />} />
            <Route path='/neighborhood' element={<Screens.Company.NeighborhoodContainer />} />
          </>
        )}

        <Route path='/*' element={<NotFound />} />
      </Routes>
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default LocationScreens;
